import styled from 'styled-components';
import { CommonState, ToolbarButton } from '../../styled/Button';

export const StyledDropdownButtonWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  color: ${(props) => props.theme.colors.gray600};
  ${CommonState};
`;

export const StyledToolOptionsWrapper = styled(StyledDropdownButtonWrapper)`
  position: relative;

  .toolArrow {
    font-size: 0.9rem;
  }
`;

export const ToolbarDropdownButton = styled(ToolbarButton)`
  &:disabled,
  &:disabled:hover {
    cursor: not-allowed;
    opacity: 0.5;

    svg {
      fill: ${(props) => props.theme.colors.gray800};
      stroke: ${(props) => props.theme.colors.gray800};
    }

    span {
      color: ${(props) => props.theme.colors.gray800};
      background: transparent;
      padding: 0;
    }
  }

  &.enabled {
    @media (hover: hover) {
      &:focus {
        background-color: transparent;
      }
    }
  }
`;

export const DropdownButtonMenu = styled.div`
  top: 100%;
  left: 0;
  width: fit-content;
  position: absolute;
  display: flex;
  flex-direction: column;
  z-index: 999999999;
  max-height: 80vh;
  overflow-y: auto;
  font-size: 1rem;
  --dropdown-border-color: #F5F5F57F;
  --dropdown-separator-color: #F5F5F527;
  border: 1px solid var(--dropdown-border-color);
  border-radius: 6px;

  &.zoom-options-menu svg {
    transform: scale(1.125);
  }

  @media screen and (max-width: ${(props) => props.theme.sizes.desktop}) {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999999999;
    display: flex;
    align-items: stretch;
    justify-content: flex-start;
    overflow-y: auto;
    width: max-content;
    min-width: 0;
    max-width: min(12rem, calc(100vw - 1rem));
    max-height: calc(100vh - 1rem);
    box-sizing: border-box;
    background-color: ${(props) => props.theme.colors.black};
    visibility: visible;
    border: 1px solid var(--dropdown-border-color);
    border-radius: 6px;

    @supports (height: 100dvh) {
      max-height: calc(100dvh - 1rem);
    }
  }
`;

export const DropdownButtonMenuOption = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  padding: 0.5em;
  background-color: ${(props) => props.theme.colors.black};
  color: ${(props) => props.theme.colors.gray700};
  border: none;
  white-space: nowrap;

  &:not(:last-child) {
    border-bottom: 1px solid var(--dropdown-separator-color);
  }

  svg {
    margin: 0 auto 0 0;
    fill: ${(props) => props.theme.colors.gray700};
    stroke: ${(props) => props.theme.colors.gray700};
  }

  svg + span {
    padding-left: 4px;
  }

  span {
    margin: 0 2px;
    color: ${(props) => props.theme.colors.gray700};
  }

  @media (hover: hover) {
    &:hover:not(:disabled) {
      color: ${(props) => props.theme.colors.smokeWhite};

      svg {
        fill: ${(props) => props.theme.colors.smokeWhite};
        stroke: ${(props) => props.theme.colors.smokeWhite};
      }

      span {
        color: ${(props) => props.theme.colors.smokeWhite};
      }
    }
  }

  @media screen and (max-width: ${(props) => props.theme.sizes.desktop}) {
    border: none;
    box-sizing: border-box;
    width: 100%;
    padding: 0.5rem;
    background-color: ${(props) => props.theme.colors.black};
    color: ${(props) => props.theme.colors.gray700};
    white-space: normal;
    text-align: left;
  }

  &:active:not(:disabled) {
    background-color: ${(props) => props.theme.colors.grayBlackShadow};
    color: ${(props) => props.theme.colors.smokeWhite};
  }

  &:disabled,
  &:disabled:hover {
    cursor: not-allowed;
    pointer-events: none;

    svg,
    span {
      opacity: 0.45;
      color: ${(props) => props.theme.colors.gray700};
      fill: ${(props) => props.theme.colors.gray700};
      stroke: ${(props) => props.theme.colors.gray700};
    }
  }

  ${CommonState}
`;
